<template>
  <CommonAddon>
    <template #unassign>
      <subtitle :sub-title="$t('billing.zr.remember_remove_rooms', [unassignLicenses, billingDate])" />
        <user-management-cta is-zr :cta-name="$t('billing.zr.unassign_rooms')" :utm-content='UTM_CONTENT_CODE.unassignRooms' />
        <view-account type='plain' />
    </template>
    <template #upsell>
      <subtitle :sub-title="$t('billing.success.confirmation.user_assign_desc')" />
      <user-management-cta is-zr :cta-name="$t('billing.success.confirmation.user_cta')" :utm-content='UTM_CONTENT_CODE.assignLicenseToUsers' />
    </template>
  </CommonAddon>
</template>
<script>
import CommonAddon from '@/views/succezz/components/common-addon.vue';
import UserManagementCta from '@/views/succezz/thanks-template/user-management-cta.vue';
import ViewAccount from '@/views/succezz/thanks-template/view-account.vue';
import Subtitle from '@/views/succezz/thanks-template/subtitle.vue';
export default {
  components: { Subtitle, ViewAccount, UserManagementCta, CommonAddon },
  mixins: [CommonAddon]
}
</script>
